import { Empty, Skeleton } from "antd";
import dayjs from "dayjs";

const MonthlyLeavesReport = ({
  checked,
  checked2,
  date,
  filter,
  filteredData,
  monthlyLeavesReport,
  details,
  loading,
}) => {
  return (
    <>
      {loading ? (
        <>
          <Skeleton active={loading} />
        </>
      ) : monthlyLeavesReport.length === 0 ? (
        <>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </>
      ) : (
        <>
          <table className="leave-report merged-table" id="myTable">
            <thead>
              <tr>
                <th className="sticky-col sticky-header" colSpan={6}>
                  Employee Info
                </th>

                <th colSpan={checked2.length + 2}>
                  {details.fromDate !== "" && details.toDate !== "" ? (
                    <>
                      {dayjs(details.fromDate).format("DD MMM YYYY")} to{" "}
                      {dayjs(details.toDate).format("DD MMM YYYY")}
                    </>
                  ) : (
                    <>{dayjs(date).format("MMM YYYY")}</>
                  )}
                </th>
              </tr>
              <tr>
                <th className="sticky-col sticky-header">Emp ID</th>
                <th className="sticky-col sticky-header">Employee Name</th>
                <th className="sticky-col sticky-header">Joining Date</th>
                <th className="sticky-col sticky-header">Confirmation Date</th>
                <th className="sticky-col sticky-header">Location</th>
                <th className="sticky-col sticky-header">Leaves 2025</th>

                {Array(checked.length)
                  .fill(["Opening", ...checked2, "Closing"])
                  .flat()
                  .map((col, i) => (
                    <th key={i}>{col}</th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {Array.isArray(monthlyLeavesReport)
                ? (filter ? filteredData : monthlyLeavesReport).map(
                    (item, idx) => (
                      <tr key={idx}>
                        <td className="sticky-col">{item.employeeId}</td>
                        <td className="sticky-col">{item.empName}</td>
                        <td className="sticky-col">{item.joiningDate}</td>
                        <td className="sticky-col">{item.confirmationDate}</td>
                        <td className="sticky-col">{item.location}</td>
                        <td className="sticky-col">{item.allocatedLeaves}</td>

                        <td>{item.monthlyAllocatedleaves}</td>
                        {checked2 && checked2.includes("Paid") ? (
                          <>
                            {" "}
                            <td>{parseFloat(item.paidleave || 0)}</td>
                          </>
                        ) : null}

                        {checked2 && checked2.includes("Goodwill") ? (
                          <>
                            {" "}
                            <td>{parseFloat(item.goodwill || 0)}</td>
                          </>
                        ) : null}
                        {checked2 && checked2.includes("Unpaid") ? (
                          <>
                            {" "}
                            <td>{parseFloat(item.unpaidLeaves || 0)}</td>
                          </>
                        ) : null}
                        {checked2 && checked2.includes("LOP/Late Mark") ? (
                          <>
                            <td></td>
                          </>
                        ) : null}
                        {checked2 && checked2.includes("Total Absent Days") ? (
                          <>
                            <td>
                              {parseFloat(item.paidleave || 0) +
                                parseFloat(item.unpaidLeaves || 0)}
                            </td>
                          </>
                        ) : null}

                        <td>{parseFloat(item.monthBalanceLeaves)}</td>
                      </tr>
                    ),
                  )
                : null}
            </tbody>
          </table>
        </>
      )}
    </>
  );
};

export default MonthlyLeavesReport;
